import { isNullOrUndefined } from 'util';
import { IRole } from '../interfaces/role';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { Iuser } from '../interfaces/user';
import { Roles } from '../enums/roles.enum';
import { ActivatedRoute } from '@angular/router';
import { UserManagementService } from 'src/app/services/user-management.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
// import Swal from 'sweetalert2';
import { EncdecService } from 'src/app/services/encdec.service';
import { ConstantsModule } from 'src/app/common/constants/constants.module';
import { AuthloginService } from 'src/app/services/login/authlogin.service';
import { SubmitdataService } from 'src/app/services/submitdata/submitdata.service';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.css']
})
export class AddUserComponent implements OnInit {

  showStateDropdown : Boolean;
  passwordtext :any;
  showerrorpwd : any;
  showerrorcnpwd : any;
  UserData : object = {password:'',confirmpassword:''};
  userForm: FormGroup = this.fb.group({
    username: new FormControl(null, [Validators.required]),
    firstName: new FormControl(null, [ Validators.pattern('^[a-zA-Z \-\']+')]),
    lastName: new FormControl(null, []),
    role: new FormControl(null, [Validators.required]),
    passwordHash: new FormControl(null, [Validators.required]),
    confirmPassword: new FormControl(null, [Validators.required]),
    mail: new FormControl(null, [Validators.required,Validators.email]),
    mobile: new FormControl(null, [Validators.pattern("[98765][0-9]{9}")]),
    // state: new FormControl('-1', [Validators.required, Validators.pattern("^((?!-1).)*$")]),
    // district: new FormControl('-1', [Validators.required, Validators.pattern("^((?!-1).)*$")]),
    countryId: new FormControl(null, []),
    countryName: new FormControl(null, []),
    stateId: new FormControl(null, [Validators.required]),
    stateName: new FormControl(null, []),
    locationId: new FormControl(null, [Validators.required]),
    locationName: new FormControl(null, []),
    locationType: new FormControl(null, []),

    // designation: new FormControl('-1', [Validators.required, Validators.pattern("^((?!-1).)*$")]),

    // secondary: new FormControl('-1', []),
  })

  locationMapping = {
    // GEC_STATE_ADMIN: {
    //   ADMIN: {
    //     cType: "DISTRICT",
    //     pType: "STATE",
    //     puuid: "",
    //     type: "district"
    //   },
    //   BASIN: {
    //     cType: "BASIN",
    //     pType: "STATE",
    //     puuid: "",
    //     type: "basin"
    //   }
    // },
    SUPER_ADMIN: {
      ADMIN: {
        cType: "STATE",
        pType: "COUNTRY",
        puuid: "",
        type: "state"
      }
    },
    ADMIN: {
      ADMIN: {
        cType: "STATE",
        pType: "COUNTRY",
        puuid: "",
        type: "state"
      }
    }
  }
  
  isBasin: boolean = false;
  currentLoggedInUserInfo = {};
  locationList: any[] = [];
  roles: IRole[] = [];
  districts: any[] = [];
  states: any[] = [];
  showError: boolean = false;
  showDistrict: boolean = false;
  userId: number;
  context: string = 'userManagement.Add';
  user: Iuser;
  userListRole: any[];
  stateArrayList: any[];
  stateList: any[];
  activeSpinner: boolean;
  showdistdrop: boolean=false;
  filterdistrict: any;
  distctSelected: boolean;
  constructor(
    private userService: UserManagementService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private modal: NgbActiveModal,
    private toastrService: ToastrService,
    private encdecservice : EncdecService,
    private constant : ConstantsModule,
    private toastr : ToastrService,
    private authservice : AuthloginService,
    private constants : ConstantsModule,
    private submitdataservice : SubmitdataService,
  ) { }

  ngOnInit() {
    this.passwordtext = this.constant.PASSWORD_STANDARD;
    this.setCurrentLoggedInUserInfo();
    this.getstateslist();
    this.loadData();
    if (this.user) {
      this.userId = this.user.userId;
      if (!isNullOrUndefined(this.userId)) {
        this.context = 'userManagement.Update';
        this.loadUserData();
        this.userForm.get('passwordHash').clearValidators();
        this.userForm.get('confirmPassword').clearValidators();
        this.loadLocations("edit");
      }
    } else {
      this.setDefaultFormControls();
      this.loadLocations("add");
    }
  }

  getCtrl(ctrlName) {
    return !isNullOrUndefined(this.userForm.controls[ctrlName]) ? this.userForm.controls[ctrlName] : null;
  }

  hasError(ctrlName) {
    return (this.getCtrl(ctrlName).touched || this.getCtrl(ctrlName).dirty) && !isNullOrUndefined(this.getCtrl(ctrlName).errors);
  }

  setCurrentLoggedInUserInfo() {
    this.currentLoggedInUserInfo["role"] = this.userService.getLoggedInUserRole();
    this.currentLoggedInUserInfo["userLocationDetails"] = this.userService.getLoggedInUserDetailsJson();
  }
  roleChanged(role){
    this.showStateDropdown = false;
    if(role == 'STATE_NODAL_OFFICER' || role == 'DISTRICT_GANGA_COMMITTEE'){
      this.showStateDropdown = true;
    }
  }
  keyPress(event: any,contact) {
    const pattern = /[0-9\+\-\ ]/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar) && contact.length != 10) {
      event.preventDefault();
    }
  }
  allowalpha(event){
    let charCode = (event.which) ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  setDefaultFormControls() {
    this.userForm.patchValue({
      countryId: this.currentLoggedInUserInfo['userLocationDetails']['countryId'],
      countryName: this.currentLoggedInUserInfo['userLocationDetails']['countryName']
    });
    // if (this.currentLoggedInUserInfo['role'] == 'GEC_STATE_ADMIN') {
    //   this.userForm.patchValue({
    //     stateId: this.currentLoggedInUserInfo['userLocationDetails']['stateId'],
    //     stateName: this.currentLoggedInUserInfo['userLocationDetails']['stateName']
    //   });
    // }
  }

  public pswdValidate(pswd,str){
    let passw = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,20}$/
    if(pswd.match(passw)) 
    { 
      str == 'password' ? this.showerrorpwd = false : this.showerrorcnpwd = false;
    } else{
      str == 'password' ? this.showerrorpwd = true : this.showerrorcnpwd = true;
    }   
  }
  loadUserData() {
    // console.log(this.user);
    
    this.userForm.patchValue({
      username: this.user.username || null,
      firstName: this.user.firstName || null,
      lastName: this.user.lastName || null,
      role: this.user.roles[0] || null,
      mail: this.user.email != 'null' ? this.user.email : null,
      passwordHash: this.user.passwordHash || null,
      mobile: this.user.mobileNo || null,
      countryId: this.user.userDetailsJson && this.user.userDetailsJson.countryId ? this.user.userDetailsJson.countryId : null,
      countryName: this.user.userDetailsJson && this.user.userDetailsJson.countryName ? this.user.userDetailsJson.countryName : null,
      stateId: this.user.userDetailsJson && this.user.userDetailsJson.stateId ? this.user.userDetailsJson.stateId : null,
      stateName: this.user.userDetailsJson && this.user.userDetailsJson.stateName ? this.user.userDetailsJson.stateName : null,
      locationId: this.user.userDetailsJson && this.user.userDetailsJson.locationId ? this.user.userDetailsJson.locationId : null,
      locationName: this.user.userDetailsJson && this.user.userDetailsJson.locationName ? this.user.userDetailsJson.locationName : null,
      locationType: this.user.userDetailsJson && this.user.userDetailsJson.locationType ? this.user.userDetailsJson.locationType : null,
    })
    if(this.user.roles[0] == 'STATE_NODAL_OFFICER'){
      this.roleChanged("STATE_NODAL_OFFICER")
    }
  }

  // loadUserData() {
  //   this.userForm.setValue({
  //     username:this.user.username || null,
  //     firstName: this.user.firstName || null,
  //     lastName: this.user.lastName || null,
  //     role: this.user.roles[0] || null,
  //     mail: this.user.email != 'null' ? this.user.email : null,
  //     passwordHash: this.user.passwordHash || null,
  //     status: true ,
  //     mobile: this.user.mobileNo || null,
  //     state: this.user.userDetailsJson && this.user.userDetailsJson.stateId ? this.user.userDetailsJson.stateId : '-1',
  //     district: this.user.userDetailsJson && this.user.userDetailsJson.lo ? this.user.userDetailsJson.district : '-1',
  //   })

  //   this.loadDistricts('load');
  // }

  async loadData() {
    this.userListRole = [];
    // Load Roles.
    let userRole = this.userService.getLoggedInUserRole();
    this.userService.getRoles(userRole).subscribe((res: any) => {
      Object.keys(res).forEach(obj=>{
        Object.keys(res[obj]).forEach(item=>{
          let role;
          // let roles = {};
          // roles['dgcVa'] = res[obj][item]['ADMIN']['ADMIN'][1];
          role= res[obj][item]['ADMIN']['ADMIN'][1];
          this.userListRole.push(role);
             
         })
      });
    }, err => console.log(err));

  }
  getstateslist(){
    let postdata = {};
    // this.locationList = [];
    this.stateList = [];
    postdata['pType'] = this.constants.LOCATION_CONSTANT['BASIN'];
    postdata['cType'] = this.constants.LOCATION_CONSTANT['STATE'];
    postdata["component"] = "";
    postdata["src"] = "";
    this.submitdataservice.getLocationList(postdata).subscribe(data =>{
      if(data){
         this.stateArrayList = [];
           Object.keys(data).forEach(key =>{
          data[key].forEach(state => {
            // this.locationList.push(statelist);
            // this.locationList.sort((a, b) => (a.name > b.name) ? 1 : -1);
            this.stateList.push(state);
            this.stateList.sort((a, b) => (a.name > b.name) ? 1 : -1);
            // this.filterDropDownLists['GroupList'] = this.groupListForMultiDropDown(this.statelists,true);
  
          });
        })
      }
    })
  
  }
  getlocationdetails() {
    this.locationList = []
    let option = {
      'pType': this.constants.LOCATION_CONSTANT['STATE'],
      'cType': this.constants.LOCATION_CONSTANT['DISTRICT'],
      'puuid': this.userForm.value.stateId//this.filterdistrict
    };
    this.activeSpinner = true;
    this.submitdataservice.getLocationListforUser(option).subscribe(data => {
      this.activeSpinner = false;
      if (Array.isArray(data)) {
        this.locationList = data;
        this.locationList.sort((a, b) => (a.name > b.name) ? 1 : -1);
      }
      // else
      //  this.fieldDropDownList['DistrictList'] = [];

    }, function (err) {
      this.activespineer = false;
      if (err['error']) {
        this.toastr.error(err['error']['msg'])
      }
    })
  }

  // getStateHierarchy() :Promise<any>{

  //   let isBasin = false;
  //   let locationId = this.currentLoggedInUserInfo['userLocationDetails']['locationId'];;

  //    let promise = new Promise((resolve, reject) => {
  //    this.userService.getStateHierarchy(locationId).subscribe((res: any) => {
  //     let response = res || {};
  //     if(response && response['hierarchy']){
  // isBasin = true;
  // }
  // console.log("\n this.response \n ", response, isBasin);
  //             resolve(isBasin);
  //      }, err => {
  //        console.log("Error Occurred", err);
  //        reject(isBasin);
  //      });

  //  });
  //  return promise

  //  }

  async loadLocations(evtSrc?: string) {

    let userRole = this.userService.getLoggedInUserRole();
    // if (userRole == "GEC_STATE_ADMIN") {
    //   this.isBasin = await this.userService.getStateHierarchy(this.currentLoggedInUserInfo['userLocationDetails']['locationId']);
    // }

    let postObj;
    if (this.isBasin) {
      postObj = this.locationMapping[this.currentLoggedInUserInfo["role"]]['BASIN'];
    } else {
      postObj = this.locationMapping[this.currentLoggedInUserInfo["role"]]['ADMIN'];
    }

    postObj.puuid = this.currentLoggedInUserInfo['userLocationDetails']['countryId'];

    //console.log("*************", postObj,this.isBasin);
    this.userService.getLocationList(postObj).subscribe((res: any) => {
      this.locationList = this.sortLocations(res);
    }, err => console.log(err));
  }

  // loadDistricts(evtSrc: string) {
  //   let role = this.getCtrl('role').value;
  //   this.showDistrict = role == Roles.USER_BASE || role == Roles.USER_ZONE;
  //   if(this.showDistrict){
  //     this.getDistrictList(evtSrc);
  //   }  
  // }

  async setLocation(locType: String) {
    if (locType == 'STATE') {
      //let index = this.locationList.findIndex(location => location['uuid'] == this.userForm.value.stateId);
      let index = this.stateList.findIndex(location => location['uuid'] == this.userForm.value.stateId);
      this.showdatafordist(this.userForm.value.stateId);
      this.getlocationdetails();
      if (index > -1) {
        // let selectedStateName = this.locationList[index]['name'];
        let selectedStateName=this.stateList[index]['name'];
        // console.log('selectedstate',selectedStateName);
        this.userForm.patchValue({
          stateName: selectedStateName,
          locationType: 'STATE',
          locationName: selectedStateName,
          locationId: this.userForm.value.stateId,
          countryName: "INDIA",
          countryId: "ffce954d-24e1-494b-ba7e-0931d8ad6085"
        });
        // console.log("\n this.userForm \n ", this.userForm.value);
      }
    } else {
      // console.log('district--',this.locationList);
      let index = this.locationList.findIndex(location => location['uuid'] == this.userForm.value.locationId);
      console.log('index',index);
      if (this.isBasin) {
        locType = 'BASIN';
      } else {
        locType = 'DISTRICT';
      }
      if (index > -1) {
        let selectedDistrictName = this.locationList[index]['name'];
        this.userForm.patchValue({
          locationType: locType,
          locationName: selectedDistrictName,
          countryName: "INDIA",
          countryId: "ffce954d-24e1-494b-ba7e-0931d8ad6085"
        });
        //  console.log("\n this.userForm \n ", this.userForm.value);
         this.distctSelected = true;
      } else { 
        this.distctSelected = false; }
      
      
    }
  }
  showdatafordist(stateuuid) {
    this.filterdistrict = stateuuid;
    if (stateuuid) {
      this.showdistdrop = true;
    } else {
      this.showdistdrop = false;
    }
    if (this.showdistdrop) {
      this.getlocationdetails();
    }
    // this.selectedId.emit(stateuuid)
  }

  // getDistrictList(evtSrc: string) {
  //   if (evtSrc == 'change') {
  //     this.resetLocations();
  //   }
  //   this.userService.getDistricts().subscribe((res: any) => {
  //     this.districts = this.sortLocations(res.result.content);
  //   }, err => console.log(err));
  // }

  sortLocations(data) {
    // return data.sort((a, b) => a.name - b.name);
    return data.sort((a, b) => a['name'] > b['name'] ? 1 : -1);
  }

  handleAddUser() {
    this.showError = true;
    if (this.userForm.valid) {
      let temp = this.userForm.value;
      let username = temp.username ? this.encdecservice.rsaenc(this.constant.PUBLIC_KEY,temp.username) : temp.username
      let email = temp.mail ? this.encdecservice.rsaenc(this.constant.PUBLIC_KEY,temp.mail) : temp.mail
      let mobile = temp.mobile ? this.encdecservice.rsaenc(this.constant.PUBLIC_KEY,temp.mobile) : temp.mobile
      // console.log(mobile,this.encdecservice.rsadec(this.constant.PRIVATE_KEY,mobile))
      let userData: Iuser = {
        username: username,
        firstName: temp.firstName,
        lastName: temp.lastName || '',
        roles: temp.role,
        email: email || '',
        mobileNo: mobile || '',
        status: 1,
        passwordHash: temp.passwordHash ? this.encdecservice.rsaenc(this.constant.PUBLIC_KEY,temp.passwordHash) : temp.passwordHash,
        userDetailsJson: {
          stateName: temp.stateName,
          stateId: temp.stateId,
          countryId: temp.countryId,
          countryName: temp.countryName,
          locationType: temp.locationType,
          locationName: temp.locationName,
          locationId: temp.locationId,
          permissions: {
            25: {
              PERMITTED: [
                {
                  entityType: temp.locationType ?  (temp.locationType).toString().toUpperCase() : null,
                  entityList: [
                    temp.locationId
                  ]
                }
              ]
            }
          }
        }
      }

      if (temp.passwordHash == temp.confirmPassword) {
        let postdata = {
          ...userData,
          roles: [userData.roles],
          userInfoEncrypted : true
        }

        if (this.user) {
          postdata.userId = this.user.userId;
          this.userService.updateUser(postdata).subscribe((res: any) => {
            if (res.result.success) {
              // Swal.fire('Success...', res.result.content, 'success');
              this.modal.close();
            } else {
              if(res.result.status != 406 || res.result.status != 420){
              // Swal.fire('Failure...', res.result.content, 'error');
              } if(res.result.status == 420){
                this.authservice.logoutuserandsessionclear();
              }
            }
          }, (err) => {
            // Swal.fire('Failure...', err.message, 'error');
          })
          return;
        }
        this.userService.createUser(postdata).subscribe((res: any) => {
          if (res.result.success) {
            this.toastr.success(res.result.content);
            this.modal.close();
          } else {
            if(res.result.status != 406 || res.result.status != 420){
              this.toastr.error(res.result.content);
            } 
            if(res.result.status == 420){
              this.authservice.logoutuserandsessionclear();
            }
          }
        }, (err) => {
          // Swal.fire('Failure...', err.message, 'error');
        })
      } else {
        this.toastrService.error("Password and Confirm Password should be same");
      }
    }

  }

  resetValues() {
    this.userForm.reset();
    this.states = [];
    this.districts = [];
    this.roles = [];
  }

  resetLocations() {
    this.userForm.patchValue({
      primary: '-1',
      secondary: "-1"
    })
  }

  closeModal() {
    this.modal.dismiss();
  }

}
